import React from 'react';

/**
 * A clean, consistent section title used across schedule detail panels.
 * Brand-red accent bar + bold title, with an optional count chip.
 */
export default function SectionHeader({ title, count }) {
  return (
    <div
      className="d-flex align-items-center no-print-border"
      style={{
        gap: 10,
        margin: '4px 0 12px',
        paddingBottom: 8,
        borderBottom: '1px solid #ececec',
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: 4,
          height: 20,
          borderRadius: 4,
          backgroundColor: '#BF1D2D',
        }}
      />
      <span
        style={{
          fontFamily: 'karla, sans-serif',
          fontWeight: 700,
          fontSize: 17,
          color: '#222',
          letterSpacing: 0.2,
        }}
      >
        {title}
      </span>
      {typeof count === 'number' && (
        <span
          style={{
            fontFamily: 'karla, sans-serif',
            fontWeight: 600,
            fontSize: 12,
            color: '#BF1D2D',
            backgroundColor: 'rgba(191,29,45,0.08)',
            borderRadius: 999,
            padding: '2px 10px',
            lineHeight: 1.6,
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
}
